import { keyframes } from '@emotion/react';

const fadeUp = keyframes`
    0% {
      transform: translateY(50%);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
`;

const fadeIn = keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
`;

const scaleIn = keyframes`
    0% {
      transform: scale(0.4);
      opacity: 0;
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
`;

const revealFromBottom = keyframes`
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0%);
    }
`;

export { fadeIn, fadeUp, scaleIn, revealFromBottom };
